const colors = ["#8884d8", "#ff7300", "#80c8d9"];

export const randomColorPicker = () => {
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};
